import React from 'react';
import { Avatar } from 'antd';
import Styles from './styles';
import { capitalize, getFirstLetter } from '../../../../utils/text';
import { formatDate, secondsToTime } from '../../../../utils/dateUtils';
import { reactions } from '../../../video/components/VideoPlayer/Controls/Reactions/reactions';
import { format } from 'date-fns';

const { TextContent, ReactionLineContainer, DetailsContainer, Speaker, Timestamp, Reaction } =
  Styles;

interface Props {
  user: string;
  reaction: string;
  timestamp: number;
  createdAt: string;
}

export const ReactionLine: React.FC<Props> = ({ user, reaction, timestamp, createdAt }) => {
  return (
    <ReactionLineContainer>
      <Avatar>{capitalize(getFirstLetter(user))}</Avatar>
      <TextContent>
        <DetailsContainer title="" style={{ height: '24px' }}>
          <Speaker>{user}</Speaker>
          <Timestamp>
            {secondsToTime(timestamp)} -- {format(new Date(createdAt), 'MM/dd/yyyy HH:mm')}
          </Timestamp>
        </DetailsContainer>
        <Reaction>
          {user} reacted with {reactions[reaction]}
        </Reaction>
      </TextContent>
    </ReactionLineContainer>
  );
};
